export default __webpack_public_path__ + "static/media/confrence-white.58693154.svg";